/**
 * Created by chensongbing on 2018/2/7.
 */
const SHOW_MODIFY_PWD = 'common/SHOW_MODIFY_PWD';
const GET_NAV_DATA= 'common/GET_NAV_DATA';
const GET_BREADCRUMB_DATA_NUM= 'common/GET_BREADCRUMB_DATA_NUM';
const SHOW_SELECT_OPTION= 'common/SHOW_SELECT_OPTION';
const UPDATE_PAGINATION_DATA= 'common/UPDATE_PAGINATION_DATA';
const CHANGE_IMG_VIEW_LIST= 'common/CHANGE_IMG_VIEW_LIST';
const CHANGE_IMG_VIEW_SHOW= 'common/CHANGE_IMG_VIEW_SHOW';
const CHANGE_IMG_VIEW_ACTIVE_INDEX= 'common/CHANGE_IMG_VIEW_ACTIVE_INDEX';
const CHANGE_LOADING_STATUS= 'common/CHANGE_LOADING_STATUS';
const CHANGE_LOADING_PERSON = 'common/CHANGE_LOADING_PERSON';
const initialState = {
    showModifyPwd:false,            //修改密码
    LoginPerson:{
        progress  :'',
        username  :'',
        mobilephone :'',
        peoplename  :'',
        authc_status  :'',
        degree:'',
        email  :'',
        sex:'',
        idNo:'',
    },
    navData:{                        //导航数据
        navList:[],
    },
    paginationData:{                //翻页数据
        selectOpen:false,          //是否点开了多少条数据/一页的select
        pageDataNum:0,            //数据总数
        pageTotalNum:0,             //总页数
        pageShowNum:10,             //多少条数据/一页
        currentPage:1,              //当前页数
        towardPage:false,     
        backPage:false,
        startPage:0
    },
    loadingStatus:{
        status:false,
        tip:""
    },

    breadcrumbData:{                //面包屑数据
        breadcrumbList:[]
    },
    imgViewData:{                  //图片展示数据
        imgViewList:[],
        visible:false,
        activeIndex:0
    },
};

const showModifyPwdReducer =  (showModifyPwd=false, action)=>{
    switch(action.type)
    {
        case SHOW_MODIFY_PWD:
            return action.data;
        default:
            return showModifyPwd
    }
};

const paginationDataReducer =  (paginationData={}, action)=>{
    switch(action.type)
    {
        case UPDATE_PAGINATION_DATA:
            return {
                ...paginationData,
                [action.subType]:action.data
            }
        case SHOW_SELECT_OPTION:
            let obj = {...paginationData}
            let data = !obj.selectOpen
            return {
                ...paginationData,
                selectOpen:data
            }
        default:
            return paginationData
    }
};
const navDataReducer =  (navData={}, action)=>{
    switch(action.type)
    {
        case GET_NAV_DATA:
            return {
                ...navData,
                navList:action.data
            }
        default:
            return navData
    }
};
const breadcrumbDataReducer =  (breadcrumbData={}, action)=>{
    switch(action.type)
    {
        case GET_BREADCRUMB_DATA_NUM:
            return {
                ...breadcrumbData,
                breadcrumbList:action.data
            }
        default:
            return breadcrumbData
    }
};
const imgViewDataReducer =  (imgViewData={}, action)=>{
    switch(action.type)
    {
        case CHANGE_IMG_VIEW_LIST:
            return {
                ...imgViewData,
                imgViewList:action.data
            }
        case CHANGE_IMG_VIEW_SHOW:
            return {
                ...imgViewData,
                visible:action.data
            }       
        case CHANGE_IMG_VIEW_ACTIVE_INDEX:
            return {
                ...imgViewData,
                activeIndex:action.data
            }
        default:
            return imgViewData
    }
};
const loadingReducer =  (loadingData={}, action)=>{
    switch(action.type)
    {
        case CHANGE_LOADING_STATUS:
            return {
                ...loadingData,
                status:action.data.status,
                tip:action.data.tip,
            }
        default:
            return loadingData
    }
};
const loadingPersonReducer =  (loadingData={}, action)=>{
    switch(action.type)
    {
        case CHANGE_LOADING_PERSON:
            return {
                ...loadingData,
                sex:action.data.sex,
                progress  :action.data.progress,
                username  :action.data.username,
                mobilephone :action.data.mobilephone,
                peoplename  :action.data.peoplename,
                authc_status  :action.data.authc_status,
                degree:action.data.degree,
                email  :action.data.email,
                idNo  :action.data.idNo,
            }
        default:
            return loadingData
    }
};
export default (state = initialState, action) => {
    return {
        showModifyPwd: showModifyPwdReducer(state.showModifyPwd, action),        //修改密码
        paginationData: paginationDataReducer(state.paginationData, action),     //翻页
        navData: navDataReducer(state.navData, action),                          //导航
        breadcrumbData: breadcrumbDataReducer(state.breadcrumbData, action),     //面包屑
        imgViewData: imgViewDataReducer(state.imgViewData, action),           //面包屑
        loadingStatus: loadingReducer(state.loadingStatus, action),           //面包屑
        LoginPerson: loadingPersonReducer(state.LoginPerson, action),           //面包屑
    };
}

export const dispatch_common_func = {
    dispatch_change_person: (data) => {
        return dispatch => {
            dispatch({
                type: CHANGE_LOADING_PERSON,
                data: data
            });
        }
    },    
    dispatch_get_navData: (data) => {
        return dispatch => {
            dispatch({
                type: GET_NAV_DATA,
                data: data
            });
        }
    },
    dispatch_loading_status: (status,tip) => {
        return dispatch => {
            dispatch({
                type: CHANGE_LOADING_STATUS,
                data: {status:status,tip:tip}
            });
        }
    },
    dispatch_get_breadcrumbData: (data) => {
        return dispatch => {
            dispatch({
                type: GET_BREADCRUMB_DATA_NUM,
                data: data
            });
        }
    },

    dispatch_show_modifyPwd: (data) => {
        return dispatch => {
            dispatch({
                type: SHOW_MODIFY_PWD,
                data: data
            });
        }
    },
    dispatch_show_select: () => {
        return dispatch => {
            dispatch({
                type: SHOW_SELECT_OPTION
            });
        }
    },
    update_paginationData: (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_PAGINATION_DATA,
                data:data,
                subType:type
            });
        }
    },
    dispatch_change_imgViewList: (data) => {
        return dispatch => {
            dispatch({
                type: CHANGE_IMG_VIEW_LIST,
                data:data
            });
        }
    },
    dispatch_change_imgViewVisible: (data) => {
        return dispatch => {
            dispatch({
                type: CHANGE_IMG_VIEW_SHOW,
                data:data
            });
        }
    },    
    change_imgViewActiveIndex: (data) => {
        return dispatch => {
            dispatch({
                type: CHANGE_IMG_VIEW_ACTIVE_INDEX,
                data:data
            });
        }
    },
}


























// WEBPACK FOOTER //
// ./src/modules/common.js